import React, {Component} from "react"
import {Container, Header, Loader} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization, interpolateString, parseMultilineString} from "../utils/localization";
import Steps from "./steps/steps";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsVerified, EDUCATIONAL_AUTO_ADVANCE_SECONDS, getBenAdminGreetingName, getStepProps, isAnsel, isDistributionChannelIndividual, isRenaissance, uiFlowBenAdmin} from "../utils/common";
import Footer from "./footer";
import {CustomDivider, CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";


const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;

    return {
        name: user.firstName,
        user: user,
        benName: getBenAdminGreetingName(benAdmin, initialData.distributionChannel),
        lang: user.lang,
        initialData: initialData, benAdmin,
        ...ownProps
    }
};

class LearnAboutUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null,
        }
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props, initialData.distributionChannel);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    render() {
        const {stepProps} = this.state;
        const localization = getLocalization(this.props.lang);
        let strings = localization.learnAboutBrella;
        const {uiFlow, distributionChannel} = this.props.initialData;
        const isBenAdmin = uiFlow === uiFlowBenAdmin;
        const isIndividual = isDistributionChannelIndividual(distributionChannel);
        const name = isBenAdmin ? this.props.benName : this.props.name;
        const title = isIndividual ? strings.individualTitle : interpolateString(strings.title, [name]);

        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        return (
            <React.Fragment>
                <Container>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>

                    <CustomGrid container stackable textAlign={'center'} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`}>
                        <CustomGrid.Row columns={2}>
                            <CustomGrid.Column width={6} className={"niceToMeetYouTextContainer"}>
                                <Header as='h2' style={{whiteSpace: 'nowrap'}}>
                                    {parseMultilineString(title)}
                                </Header>
                                <p>
                                    <b>{parseMultilineString(strings.subTitle)}</b>
                                </p>
                                <p className={"small neutral700Text"}>{parseMultilineString(strings.description)}</p>

                            </CustomGrid.Column>
                            <CustomGrid.Column width={4}>
                                <CustomDivider hidden/>
                                <S3Image {...(isRenaissance() ? IMAGE.NICE_TO_MEET_V2 : IMAGE.NICE_TO_MEET)}/>
                            </CustomGrid.Column>
                        </CustomGrid.Row>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                    autoAdvanceSeconds={EDUCATIONAL_AUTO_ADVANCE_SECONDS}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(LearnAboutUs));
